var Geometry = require("./basicGeometry.js");
var ClipperLib = require("js-clipper");

/**
 * Attach some extra functions implemented using js-clipper.
 */

var clean_polygon_distance = 1;

/**** Conversions ****/

Geometry.Polygon.prototype.fromJSClipper = function(path) {
    this.taintCache();
    this.points = path.map(function(p){
        return new Geometry.Coord(p.X, p.Y);
    });
    return this;
};

Geometry.Polygon.prototype.toJSClipper = function() {
    var path = this.points.map(function(p){
        return {X:p.x, Y:p.y};
    });
    if(!ClipperLib.Clipper.Orientation(path))
        path = path.reverse();
    return [path];
};

Geometry.ComplexPolygon.prototype.fromJSClipper = function(path, holes) {
    Geometry.Polygon.prototype.fromJSClipper.call(this, path);
    this.holes = holes.map(function(hole){
        return hole.map(function(p){
            return new Geometry.Coord(p.X, p.Y);
        });
    });
    return this;
};

Geometry.ComplexPolygon.prototype.toJSClipper = function() {
    var paths = Geometry.Polygon.prototype.toJSClipper.call(this);
    this.holes.forEach(function(hole) {
        var path = hole.map(function(p){
            return {X:p.x, Y:p.y};
        });
        if(ClipperLib.Clipper.Orientation(path))
            path = path.reverse();
        paths.push(path);
    });
    return paths;
};


//A polyTree is a hierarchy of nested outlines and holes (outlines can contain holes, and holes can contain other outlines)
//A polyTree is the result of a clipper operation
Geometry.fromJSClipperPolyTree = function(solution_paths) {
    var polys = [];
    function polyTreeToPolygonsRec(node) {
        //Assertion disabled due to bug in jsclipper: https://github.com/platener/jsclipper/issues/10
        // console.assert(!node.IsHole(), "A hole");
        var poly;
        if(node.ChildCount() > 0) {
            var holes = node.Childs();
            var hole_contours = holes.map(function(hole) {
                // console.assert(hole.IsHole(), "Not a hole!");
                return ClipperLib.Clipper.CleanPolygon(hole.Contour(), clean_polygon_distance);
                // return hole.Contour();
            });
            var contour = node.Contour();
            contour = ClipperLib.Clipper.CleanPolygon(contour, clean_polygon_distance);
            poly = new Geometry.ComplexPolygon().fromJSClipper(contour, hole_contours);
            holes.forEach(function(hole) {
                hole.Childs().forEach(polyTreeToPolygonsRec);
            });
        } else {
            poly = new Geometry.Polygon().fromJSClipper(node.Contour());
        }
        polys.push(poly);
    }
    if(solution_paths.ChildCount() > 0) {
        solution_paths.Childs().forEach(function(child) {
            polyTreeToPolygonsRec(child);
        });
    }
    if(polys.length > 1)
        return new Geometry.MultiPolygon(polys);
    else if(polys.length === 1)
        return polys[0];
    else
        return new Geometry.Polygon();
};


/**** operations ****/

//WARNING: works with integer precision
Geometry.Polygon.prototype.buffer = function(dist, arcTolerance) {
    var paths = this.toJSClipper();
    paths = ClipperLib.Clipper.SimplifyPolygons(paths, ClipperLib.PolyFillType.pftNonZero);
    paths = ClipperLib.Clipper.CleanPolygons(paths, clean_polygon_distance);
    var miterLimit = 2;
    if(!arcTolerance)
        arcTolerance = 1;
    var co = new ClipperLib.ClipperOffset(miterLimit, arcTolerance);
    co.AddPaths(paths, ClipperLib.JoinType.jtRound, ClipperLib.EndType.etClosedPolygon);
    var offsetted_paths = new ClipperLib.PolyTree();
    co.Execute(offsetted_paths, dist);

    return Geometry.fromJSClipperPolyTree(offsetted_paths);
};

Geometry.Polygon.prototype.difference = function(other) {
    return executeClipperOperation([this], [other], ClipperLib.ClipType.ctDifference);
};

Geometry.Polygon.prototype.intersection = function(other) {
    return executeClipperOperation([this], [other], ClipperLib.ClipType.ctIntersection);
};

Geometry.MultiPolygon.prototype.difference = function(other) {
    return executeClipperOperation(this.polygons, [other], ClipperLib.ClipType.ctDifference);
};

Geometry.MultiPolygon.prototype.intersection = function(other) {
    return executeClipperOperation(this.polygons, [other], ClipperLib.ClipType.ctIntersection);
};

//WARNING: executeClipperOperation works with 1e-6 precision
var executeClipperOperation = function(outlines, holes, operation) {
    outlines = outlines || [];
    holes = holes || [];
    function convertToJSClipper(polygon) {
        return polygon.round(1e-6).toJSClipper();
    }
    var subj_paths = [];
    outlines.forEach(function (outline) {
        if(outline instanceof Geometry.MultiPolygon) {
            subj_paths = subj_paths.concat(outline.polygons.map(convertToJSClipper));
        } else {
            subj_paths.push(convertToJSClipper(outline));
        }
    });
    var clip_paths = [];
    holes.forEach(function (hole) {
        if(hole instanceof Geometry.MultiPolygon) {
            clip_paths = clip_paths.concat(hole.polygons.map(convertToJSClipper));
        } else {
            clip_paths.push(convertToJSClipper(hole));
        }
    });
    subj_paths = subj_paths.reduce(function(a, b) { return a.concat(b); }, []);
    clip_paths = clip_paths.reduce(function(a, b) { return a.concat(b); }, []);
    var cpr = new ClipperLib.Clipper();
    cpr.AddPaths(subj_paths, ClipperLib.PolyType.ptSubject, true);
    cpr.AddPaths(clip_paths, ClipperLib.PolyType.ptClip, true);
    var solution_paths = new ClipperLib.PolyTree();
    cpr.Execute(operation, solution_paths,
        ClipperLib.PolyFillType.pftNonZero, ClipperLib.PolyFillType.pftNonZero);

    return Geometry.fromJSClipperPolyTree(solution_paths);
};

//WARNING: union works with 1e-6 precision
var union = function(outlines, holes) {
    var poly = executeClipperOperation(outlines, holes, ClipperLib.ClipType.ctDifference);
    if(poly.polygons)
        return poly.polygons;
    else
        return [poly];
};

Geometry.Union = union;
